import {store} from '../utils/shared/store';

const articleBottomNavStore = store({articles: {}});

const articleBottomNavMemoryRepository = {
  subscribe: articleBottomNavStore.subscribe,

  get () {
    return articleBottomNavStore.articles;
  },

  set (articleId, isVisible = false) {
    if (!articleId) {
      return articleBottomNavStore.articles;
    }
    articleBottomNavStore.articles = {
      ...articleBottomNavStore.articles,
      [articleId]: {
        isVisible
      }
    };
  },

  clear() {
    articleBottomNavStore.articles = null;
  }
};

export {articleBottomNavMemoryRepository};
